<template>
  <div
    :class="{ fullsize: isFullSize, 'card-container': true, 'enlarged': isHovered, 'showcase': isShowcase, 'flipped': isFlipped}"
    :data-index="index"
    :style="{
      transform: isShowcase ? `translate(${delta.x}px, ${delta.y}px) ${isFlipped ? 'rotateY(180deg)' : ''} scale(1.6)` : ''
    }"
  >
    <div
      :id="{id}" ref="cardContent"
      class='card-content'
      :style="{
        transform: `perspective(600px) rotateX(${rotation.x}deg) rotateY(${rotation.y}deg) scale(${isHovered ? 1.07 : 1})`
      }"
      @mousemove="handleMouseMove"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @click="handleOnClick"
    >
      <!-- front content -->
      <div :class="[card_class, 'front']">
        <!--img class="card-img" :src="'static/assets/' + url" /-->
        <div class="image-container">
          <img class="card-img" :src="image" />
        </div>
        <div
          :class="{
            'card-edition': true,
            'plat-edition': (card_class[16] == '2'),
          }"
        >
          <span>{{ edition_label }}</span>
        </div>
        <div class="card-name">{{ name }}<br />{{ cset }}</div>
        <div class="bottom-text">
          {{ parseInt(unlock_czxp).toLocaleString() }}
        </div>
        <div class="bottom-right-corner">
          {{ level }}
        </div>
        <div class="card-booster-shop card-booster-shop-circle" />
        <div class="top-right-corner" :style="{ backgroundColor: activeColor }">
          <b-icon-lightning-fill
            v-if="in_store == 'Booster'"
            class="card-booster-shop-icon"
            scale="1.3"
          />
          <b-icon-tag-fill
            v-if="in_store == 'Store'"
            class="card-booster-shop-icon"
            scale="1.3"
          />
        </div>
        <div v-if="is_owned && used_in_cardsets" class="owned-label">OWNED</div>
        <div v-else-if="is_minted && used_in_cardsets" class="not-owned-label">
          NOT OWNED
        </div>
        <div
          v-else-if="!is_minted && used_in_cardsets"
          class="not-minted-label"
        >
          NEVER MINTED
        </div>
        <div 
          class="glare"
          :style="{
            transform:`translate(calc(${cardMousePos.x} * 65%), calc(${cardMousePos.y} * 120%))`  
          }"
        />
      </div>
      <div class="back card-bg card-bg-back-bsc">
        <div class="back-container">
          <div
            v-if="!!id && !used_in_cardsets"
            class="card-txt-black font-weight-bold"
            title="Copy link to token"
            @click="onCopyLink"
          >
            <h5 id="share">
              Token #{{ id }} <b-icon-link-45deg></b-icon-link-45deg>
            </h5>
          </div>
          <div class="card-txt-black">
            <span class="attribute-name font-weight-bold">GLMR Cost:</span>
            <span>{{ cost }}</span>
          </div>
          <div class="card-txt-black">
            <span v-if="cost > 0" class="attribute-name font-weight-bold">Zoom Reward:</span>
            <span v-else-if="!card_owned || is_single_card_view" class="attribute-name font-weight-bold">Zoom Burn:</span>
            <span v-if="(!card_owned || is_single_card_view) || cost > 0">{{ parseInt(buy_czxp).toLocaleString() }}</span>
          </div>
          <div class="card-txt-black">
            <span class="attribute-name font-weight-bold">Sacrifice earn ZOOM:</span>
            <span>{{ parseInt(sacrifice_czxp).toLocaleString() }}</span>
          </div>
          <p class="text-center">
            <img src="https://zoombies.world/images/moonbeam_label.svg" class="mr-logo" />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showcaseEventBus } from "../util/showcaseEventBus"; //GLOBAL VARIABLES
import { BIconLink45deg } from "bootstrap-vue";
import { showErrorToast, showSuccessToast } from "../util/showToast";

export default {
  name: "OwnedCardContent",
  props: [
    "id",
    "type_id",
    "name",
    "image",
    "edition_current",
    "edition_total",
    "cset",
    "unlock_czxp",
    "level",
    "cost",
    "buy_czxp",
    "sacrifice_czxp",
    "card_class",
    "in_store",
    "card_owned",
    "is_single_card_view",
    "index",
    "observer",
    "is_plat",
    "used_in_cardsets",
    "is_minted",
    "is_owned",
  ],
  components: {
    BIconLink45deg,
  },
  data() {
    return {
      isFlipped: false,
      isFlipping: false,
      isHovered: false, //true when mouse is over card
      isShowcase: false,
      transitionTimer: null, //timer for transition between front and back of card
      repositionTimer: null, //timer for repositioning card
      delta: { //distance from card to center of screen
        x: 0,
        y: 0,
      },
      rotation: { //degrees to rotate card
        x: 0,
        y: 0,
      },
      cardMousePos: {
        //tracks the x and y coordinates of the mouse relative to a card
        x:0,
        y:0,
      },
      sparklePos: {
        //calculated coordinates for translation of background effects
        x:0,
        y:0,
      },
      glrPos: {
        //calculated coordinates for gradients and background lighting
        x:0,
        y:0,
      }
    };
  },
  computed: {
    activeColor() {
      if (this.in_store == "Store") {
        return "#FFA500"; //orange
      } else {
        return "#F8FF02"; //yellow
      }
    },
    edition_label() {
      if (this.used_in_cardsets) {
        if (this.edition_total === "0") {
          return "Unlimited";
        } else {
          return `Edition Total: ${this.edition_total}`;
        }
      }

      if (!this.card_owned) {
        return this.edition_current + "/" + this.edition_total;
      } else {
        if (this.edition_total === 0) {
          return "#" + this.edition_current;
        } else {
          return "#" + this.edition_current + " of " + this.edition_total;
        }
      }
    },
    isFullSize() {
      return this.is_single_card_view;
    },
  },
  mounted() {
    //called when mounted
    if (showcaseEventBus.showcasedCard && showcaseEventBus.showcasedCard !== this) { //if a card is being showcased and it is NOT THIS card, prevent interaction
      this.$refs.cardContent.style.pointerEvents = "none";
    }

    //listener for showcase event
    showcaseEventBus.$on("showcase", (showcasedCard) => {
      if (showcaseEventBus.showcasedCard && showcaseEventBus.showcasedCard !== this) { //if a card is being showcased and it is NOT THIS card, prevent interaction
        this.$refs.cardContent.style.pointerEvents = "none";
      }
      else {
        this.$refs.cardContent.style.pointerEvents = "auto"; //otherwise allow interaction
      }
    })

    //
    if (this.observer) {
      this.observer.observe(this.$el);
    }
  },
  beforeUnmount() {
    showcaseEventBus.$off("showcase");
  },
  watch: {
    //TWO MODULES MERGED INTO ONE:
    //1. stop showcasing when clicked outside of card
    //2. reposition showcased card when window is resized
    isShowcase(isShowcaseCur, isShowcasePrev) {

      const outsideClickListener = (event) => { //1
        if (this.isShowcase && event && this.$refs.cardContent && !this.$refs.cardContent.contains(event.target) && !this.isFlipping) { //if clicked OUTSIDE of card AND card is not flipping
          //stop showcasing
          this.isShowcase = false;
          this.isFlipped = false;
          this.isFlipping = false;
          this.delta = { x: 0, y: 0 };
          showcaseEventBus.setShowcasedCard(null);
          showcaseEventBus.$emit("showcase", null); //tell other cards this card is no longer showcasing
        }
      }
      
      const reposition = (() => { //2
        clearTimeout(this.repositionTimer);
        this.repositionTimer = setTimeout(() => {
          if (this.isShowcase) {
            this.setCenter(this.delta);
          }
        }, 300); //this value is independent of the card transition time
      });


      if (!isShowcaseCur) { //clean up existing listeners and timeouts
        clearTimeout(this.repositionTimer); //1
        document.removeEventListener('click', outsideClickListener); //1

        window.removeEventListener("scroll", reposition); //2
        window.removeEventListener("resize", reposition); //2
      }

      else { //isShowcaseCur is true
        document.addEventListener('click', outsideClickListener); //1

        window.addEventListener("scroll", reposition, true); //2 //useCapture = true. Necessary as a child seems to be blocking propagation to window
        window.addEventListener("resize", reposition); //2
      }
    },

    //when isFlipped changes, set isFlippedPrev to the previous value of isFlipped after transition time
    isFlipped(isFlippedCur, isFlippedPrev) {
      clearTimeout(this.transitionTimer); //contingency plan if someone changes transition time without updating timeout delay
      this.isFlipping = true;
      this.transitionTimer = setTimeout(() => { //wait out transition before accepting new flip request (handled by outsideClickListener() and handleOnClick())
        this.isFlipping = false;
      }, 300); //delay is 200ms shorter than flip animation for responsiveness
    },

  },
  methods: {
    handleMouseMove(event) {
      const { clientX, clientY } = event;
      const { left, top, width, height } = this.$refs.cardContent.getBoundingClientRect(); //left = left edge of viewport to left edge of card, top = top edge of viewport to top edge of card

      //mouse position within the card
      let x, y;
      if (!this.isFlipped) {
          x = (clientX - left) / width; //ranges from 0 to 1
          y = (clientY - top) / height; //ranges from 0 to 1
          var px = Math.abs(Math.floor(100 / width * clientX)-100);
          var py = Math.abs(Math.floor(100 / height * clientY)-100);
          var lp = (60+(px - 50)/1.1)+10;
          var tp = (60+(py - 50)/1.1)+10;
          var px_spark = (60+(px - 30)/6);
          var py_spark = (50+(py - 30)/6);
      }
      else {
          x = 1 - ((clientX - left) / width); //x is inverted because card is mirrored when flipped
          y = (clientY - top) / height;
      }

      //saving styling coordinate values
      this.sparklePos.x = px_spark;
      this.sparklePos.y = py_spark;
      this.glrPos.x = lp;
      this.glrPos.y = tp;
      this.cardMousePos.x = x;
      this.cardMousePos.y = y;

      //calculate rotation
      const rotationX = (y - 0.5) / 0.020; // y - 0.5 to center the rotation (y ranges from -0.5 to 0.5)
      const rotationY = (x - 0.5) / 0.020; // x - 0.5 to center the rotation

      this.rotation = ({ x: rotationX, y: rotationY });
    },
    handleMouseEnter() {
      this.isHovered = true;
      this.$refs.cardContent.style.transition = ""; //card rotates responsively (no transition time)
    },
    handleMouseLeave() {
      this.isHovered = false;
      this.rotation = {x: 0, y: 0}; //reset to default
      this.$refs.cardContent.style.transition = "transform 0.3s ease"; //card returns to rest gracefully
    },
    setCenter(delta) {
      const cardContainer = this.$refs.cardContent.parentElement; //parent element has constant width and height
      const { left, top, width, height } = cardContainer.getBoundingClientRect(); //get element's position relative to viewport
      const view = document.documentElement; //get viewport size

      //distance to center of screen
      const xTranslate = Math.round((view.clientWidth / 2) - left - (width / 2));
      const yTranslate = Math.round((view.clientHeight / 2) - top - (height / 2));

      const newX = delta.x + xTranslate;
      const newY = delta.y + yTranslate;

      //update referenced delta object
      delta.x = newX;
      delta.y = newY;
    },
    handleOnClick() {
      if (!this.isShowcase) { //start showcasing when card clicked
        this.setCenter(this.delta); //set card to center of screen (pass delta by REFERENCE)
        this.isShowcase = true;
        this.isFlipped = false;
        this.isFlippedPrev = false;
        showcaseEventBus.setShowcasedCard(this);
        showcaseEventBus.$emit("showcase", this); //tell other cards this card is showcased
      }
      else if (this.isShowcase && !this.isFlipping) { //flip the card when clicked again (only if not currently flipping)
        this.isFlipped = !this.isFlipped;
        this.rotation = {x: this.rotation.x, y: -this.rotation.y}; //invert rotation (card is mirrored when flipped)
        this.$refs.cardContent.style.transition = "transform 0.5s ease"; //smooth rotation mirroring when flipping
        setTimeout(() => { //revert transition time to default (responsive rotation) after flipping
          this.$refs.cardContent.style.transition = "";
        }, 500);
      }
    },
    getTokenLink(tokenId) {
      // let url;
      // if (window.location.pathname === "/moonbase") {
      //   url = "https://moonbase.zoombies.world";
      // } else if (process.env.NODE_ENV === "development") {
      //   url = "localhost:8080";
      // } else {
      //   url = "https://movr.zoombies.world";
      // }

      // New implementation below

      let url;
            
      if (process.env.NODE_ENV === "development") {
        url = "localhost:8080";
      } else {
        url = "https://zoombies.world";
      }

      let curr_chain;
      if(window.ethereum.networkVersion == 1287) {
        curr_chain = 'moonbase';
      }
      else if(window.ethereum.networkVersion == 1284) {
        curr_chain = 'moonbeam';
      }

      return `${url}/${curr_chain}/view/${tokenId}`;
    },
    onCopyLink(event) {
      event.stopPropagation(); //stops the card from flipping when the link is clicked
      try {
        navigator.clipboard.writeText(this.getTokenLink(this.id));
        showSuccessToast(this, "Link to Token copied to clipboard");
      }
      catch (error) {
        console.error(error);
        showErrorToast(this, `Failed to copy link to clipboard: ${this.getTokenLink(this.id)}`);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* Layout */

.glare{
  position: absolute;
  pointer-events: none;
  width: 60%;
  height: 40%;
  background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.507) 0%, rgba(255, 255, 255, 0) 70%);
  filter: brightness(0.80) blur(5px) contrast(1.1);
  opacity: 0;
  transition: opacity 0.3s;
}

.card-content:hover .glare{
  opacity: 1;
}

.card-bg {
  display: inline-block;
  width: 100%;
  height: 100%;
  text-align: center;
  margin-bottom: 3px;
  padding-bottom: 4px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: 0px;
}

.card-bg-6 {
  background-image: url("https://zoombies.world/images/dapp/zoombies_card_common_brown.svg");
}

.card-bg-5 {
  background-image: url("https://zoombies.world/images/dapp/zoombies_card_uncommon_blue.svg");
}

.card-bg-4 {
  background-image: url("https://zoombies.world/images/dapp/zoombies_card_rare_red.svg");
}

.card-bg-3 {
  background-image: url("https://zoombies.world/images/dapp/zoombies_card_epic_purple.svg");
}

.card-bg-2 {
  background-image: url("https://zoombies.world/images/dapp/zoombies_card_platinum.svg");
}

.card-bg-1 {
  background-image: url("https://zoombies.world/images/dapp/zoombies_card_diamond.svg");
}

.card-bg-back-bsc {
  background-image: url("https://zoombies.world/images/dapp/zoombies_card_back.svg");
  padding: 20px;
}

.image-container {
  position: absolute;
  top: 15%;
  left: 10%;
  right: 10%;
  height: 45%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.card-img {
  width: 80%;
}

.top-right-corner {
  position: absolute;
  top: 4%;
  right: 0;
  width: 19%;
  height: 12%;
  border-radius: 50%;
  border: 3px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-right-corner {
  position: absolute;
  bottom: 1.5%;
  right: 0;
  width: 19%;
  height: 12%;
  display: flex;
  justify-content: center;
  align-items: center;

  font-weight: bold;
  color: #fff;
}

.card-edition {
  position: absolute;
  top: 62%;
  bottom: 32%;
  left: 10%;
  right: 10%;
  color: #ddd;
  font-weight: 700;
}

.plat-edition {
  color: black;
}

.card-name {
  font-weight: bold;
  position: absolute;
  left: 5%;
  right: 5%;
  top: 70%;
  bottom: 13%;
  color: black;

  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-text {
  position: absolute;
  color: #fff;
  font-weight: bold;
  left: 21%;
  right: 21%;
  bottom: 4.5%;
  height: 7%;
  text-align: left;
  display: flex;
  align-items: center;
}

.card-txt-black {
  color: #000;
}

/* Back of card stuff */
.card-txt-white {
  color: #fff;
}

.back-container {
  position: absolute;
  top: 35%;
  bottom: 16%;
  left: 8%;
  right: 7%;
  background-color: rgba(200, 200, 200, 0.7);
  padding: 5%;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

/** Card **/

/* entire container, keeps perspective */

.card-container {
  position: relative;
  margin: 0;
  height: 410px;
  width: 260px;
  font-size: 16px;
  transform: scale(1); //default size
  transition: transform 0.5s ease;
  z-index: 1;
}

.card-container.enlarged {
  transform: scale(1.05);
  z-index: 2; //put this card in front of other cards
}

.card-container.showcase {
  z-index: 9999; //put this card in front of everything
}

.card-container.flipped {
  
}

.card-content {
  height: 100%;
  width: 100%;
}

@media screen and (max-width: 1000px) {
  .card-container {
    height: calc(0.55 * 410px);
    width: calc(0.55 * 260px);
    font-size: 10px;
  }

  #share {
    font-size: 12px !important;
    margin: 0;
  }

  .fullsize {
    height: 410px !important;
    width: 260px !important;
    font-size: 16px !important;
  }
}

.front,
.back {
  pointer-events: none;
  position: absolute;
  backface-visibility: hidden;
  transition: transform 0.5s ease;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

/* front pane, placed above back */
.front {
  user-select: none;
  z-index: 2;
  /* for firefox 31 */
  transform: rotateY(0deg);
}

/* back, initially hidden pane */
.back {
  transform: rotateY(180deg);
}

.card-container.flipped .front {
  transform: rotateY(180deg);
}

.card-container.flipped .back {
  transform: rotateY(0deg) scaleX(-1);
}

.attribute-name {
  padding-right: 5px;
}

#share {
  pointer-events: auto; //overrides pointer-events: none on .back
  cursor: pointer;

  &:hover {
    color: #0645ad;
  }
}

.card-booster-shop-icon {
  color: #000000;
}

.not-minted-label,
.owned-label,
.not-owned-label {
  position: absolute;
  top: 17%;
  border-radius: 2px;
  border: 2px solid black;
  width: 100%;
  height: 15%;
  font-size: 1.5rem;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
}

@media screen and (max-width: 1000px) {
  .not-minted-label,
  .owned-label,
  .not-owned-label {
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 768px) {
  .not-minted-label,
  .owned-label,
  .not-owned-label {
    font-size: 1rem;
  }
}

.owned-label {
  background-color: #7ef4f6;
}

.not-minted-label {
  background-color: #6c757d4f;
}

.not-owned-label {
  background-color: #f566e2;
}

@media screen and (max-width: 768px) {
  .mr-logo {
    max-width: 50%;
    position: absolute;
    top: 116px;
    left: 32px;
  }
}
@media screen and (min-width: 768px) {
  .mr-logo {
    max-width: 50%;
    position: absolute;
    top: 116px;
    left: 32px;
  }
}
@media screen and (min-width: 1024px) {
  .mr-logo {
    max-width: 50%;
    position: absolute;
    top: 210px;
    left: 54px;
  }
}
</style>